import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { RiMoonClearFill, RiSunFill } from "react-icons/ri";

export default function Switch() {
  const [dark, setDark] = useState(false);
  const spring = {
    type: "spring",
    stiffness: 700,
    damping: 30,
  };

  useEffect(() => {
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      setDark(true);
      document.documentElement.classList.add("dark");
    }
  }, []);

  const handleTheme = (event) => {
    event.preventDefault(); // Prevent default behavior that could cause text selection

    if (dark) {
      document.documentElement.classList.remove("dark");
    } else {
      document.documentElement.classList.add("dark");
    }
    setDark(!dark);
  };

  return (
    <div
      onClick={handleTheme}
      className={`flex-start flex h-[35px] w-[65px] rounded-[50px] bg-white p-[5px] shadow-inner border-2 border-gray-300 dark:border-gray-600 items-center hover:cursor-pointer dark:bg-gray-500 ${
        !dark && "place-content-end"
      }`}
      style={{ userSelect: "none" }} // Prevent text selection on the switch
    >
      <motion.div
        className="flex h-[25px] w-[25px] items-center justify-center rounded-full bg-gray-700"
        layout
        transition={spring}
      >
        <motion.div whileTap={{ rotate: 360 }}>
          {!dark ? (
            <RiSunFill className="h-4 w-4 text-orange-300" />
          ) : (
            <RiMoonClearFill className="h-4 w-4 text-blue-300" />
          )}
        </motion.div>
      </motion.div>
    </div>
  );
}
